import { useState } from "react";
import Modal from "./components/Modal";
import Button from "./components/Button";
import "./Profile.css";

const API = '/api';

export default function Profile({ user, onUpdate, onClose }) {
  const [name, setName]           = useState(user.name || '');
  const [bio, setBio]             = useState(user.bio || '');
  const [website, setWebsite]     = useState(user.website || '');
  const [oldPass, setOldPass]     = useState('');
  const [newPass, setNewPass]     = useState('');
  const [confirmPass, setConfirmPass] = useState('');
  const [msg, setMsg]             = useState('');
  const [msgType, setMsgType]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [activeTab, setActiveTab] = useState('profile');

  const showMsg = (text, type) => {
    setMsg(text);
    setMsgType(type);
    setTimeout(() => setMsg(''), 3000);
  };

  const saveProfile = async () => {
    if (!name) { showMsg('Name required!', 'error'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${API}/update_profile.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, name, bio, website })
      });
      const data = await res.json();
      if (data.success) {
        const updatedUser = { ...user, name, bio, website };
        localStorage.setItem('wsncode_user', JSON.stringify(updatedUser));
        onUpdate(updatedUser);
        showMsg('Profile updated!', 'success');
      } else {
        showMsg(data.message, 'error');
      }
    } catch (e) {
      showMsg('Error!', 'error');
    }
    setLoading(false);
  };

  const changePassword = async () => {
    if (!newPass) { showMsg('New password required!', 'error'); return; }
    if (newPass !== confirmPass) { showMsg('Passwords do not match!', 'error'); return; }
    if (newPass.length < 6) { showMsg('Password must be 6+ characters!', 'error'); return; }
    setLoading(true);
    try {
      const res  = await fetch(`${API}/change_password.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.id, old_password: oldPass, new_password: newPass })
      });
      const data = await res.json();
      if (data.success) {
        showMsg('Password changed!', 'success');
        setOldPass(''); setNewPass(''); setConfirmPass('');
      } else {
        showMsg(data.message, 'error');
      }
    } catch (e) {
      showMsg('Error!', 'error');
    }
    setLoading(false);
  };

  const getInitials = (name) => {
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <Modal title="Profile Settings" maxWidth={460} onClose={onClose}>
        <div className="profile-avatar-section">
          <div className="profile-avatar">{getInitials(user.name)}</div>
          <div>
            <p className="profile-name">{user.name}</p>
            <p className="profile-email">{user.email}</p>
          </div>
        </div>

        <div className="profile-tabs">
          <button className={`profile-tab ${activeTab === 'profile'  ? 'active' : ''}`} onClick={() => setActiveTab('profile')}>Profile</button>
          <button className={`profile-tab ${activeTab === 'password' ? 'active' : ''}`} onClick={() => setActiveTab('password')}>Password</button>
        </div>

        {msg && <div className={`profile-msg ${msgType}`}>{msg}</div>}

        {activeTab === 'profile' && (
          <div className="profile-form">
            <label className="profile-label">Full Name</label>
            <input className="profile-input" type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name" />

            <label className="profile-label">Bio</label>
            <textarea className="profile-input profile-textarea" value={bio} onChange={(e) => setBio(e.target.value)} placeholder="Tell something about yourself..." rows={3} />

            <label className="profile-label">Website</label>
            <input className="profile-input" type="url" value={website} onChange={(e) => setWebsite(e.target.value)} placeholder="https://yourwebsite.com" />

            <Button variant="primary" style={{ width: '100%', marginTop: '16px' }} onClick={saveProfile} disabled={loading}>
              {loading ? 'Saving...' : 'Save Profile'}
            </Button>
          </div>
        )}

        {activeTab === 'password' && (
          <div className="profile-form">
            <label className="profile-label">Current Password</label>
            <input className="profile-input" type="password" value={oldPass} onChange={(e) => setOldPass(e.target.value)} placeholder="Current password" />

            <label className="profile-label">New Password</label>
            <input className="profile-input" type="password" value={newPass} onChange={(e) => setNewPass(e.target.value)} placeholder="New password (min 6 chars)" />

            <label className="profile-label">Confirm New Password</label>
            <input className="profile-input" type="password" value={confirmPass} onChange={(e) => setConfirmPass(e.target.value)} placeholder="Confirm new password" />

            <Button variant="primary" style={{ width: '100%', marginTop: '16px' }} onClick={changePassword} disabled={loading}>
              {loading ? 'Updating...' : 'Change Password'}
            </Button>
          </div>
        )}
    </Modal>
  );
}